<script lang="ts" setup>
import {
  getEditPageData,
  getColumnByKennung,
} from "@/editor/EditComponentStatic";

defineProps<{
  readOnlyMutable?: boolean;
}>();
defineEmits(["changeValue"]);

// Detailfelder haengen am uiData/pageParams der Elternseite (RkMitarbeiterBeleg.vue)
const { uiData } = getEditPageData();

// Je nach Aufrufkontext (zB aus der Reise heraus) fehlt die Spalte entweder ganz
// oder ist vorhanden, aber vom Server als invisible markiert - beides bedeutet: nicht anzeigen
function hasColumn(kennung: string) {
  const column = getColumnByKennung(uiData?.columns ?? [], kennung);
  return !!column && !column.meta?.invisible;
}
</script>
<template>
  <v-row v-if="uiData?.initialized" class="pt-0 beleg-details-row" dense>
    <v-col v-if="hasColumn('INVOICE_DATE')" cols="12" sm="6" class="py-0">
      <EditDatePicker kennung="INVOICE_DATE" />
    </v-col>
    <v-col v-if="hasColumn('LV_DURCHFUEHRUNG')" cols="12" sm="6" class="py-0">
      <EditDatePicker kennung="LV_DURCHFUEHRUNG" />
    </v-col>

    <v-col v-if="hasColumn('BEZEICHNUNG')" cols="12" class="py-0">
      <EditTextField
        kennung="BEZEICHNUNG"
        @changeValue="$emit('changeValue', $event)"
      />
    </v-col>
    <v-col
      v-if="hasColumn('KOSTENSTELLENZUORDNG')"
      cols="12"
      sm="6"
      class="py-0"
    >
      <EditComboBox
        kennung="KOSTENSTELLENZUORDNG"
        @changeValue="$emit('changeValue', $event)"
      />
    </v-col>
    <v-col
      v-if="hasColumn('RK_LAND')"
      cols="12"
      :sm="hasColumn('KOSTENSTELLENZUORDNG') ? 6 : 12"
      class="py-0"
      :style="
        !hasColumn('KOSTENSTELLENZUORDNG')
          ? 'flex: 0 0 100%; max-width: 100%;'
          : undefined
      "
    >
      <EditComboBox
        kennung="RK_LAND"
        @changeValue="$emit('changeValue', $event)"
      />
    </v-col>
    <v-col
      v-if="hasColumn('STATUSZAHLUNG')"
      cols="12"
      sm="12"
      class="py-0 d-flex align-center statuszahlung-col"
    >
      <EditCheckBox3
        :readonly="readOnlyMutable"
        kennung="STATUSZAHLUNG"
        @changeValue="$emit('changeValue', $event)"
      />
    </v-col>
    <v-col
      v-if="hasColumn('RK_SONSTIGEBELEGE_VOLLSTAENDIG_KI')"
      cols="12"
      sm="6"
      class="py-0 tight-top"
    >
      <EditSwitchButton
        kennung="RK_SONSTIGEBELEGE_VOLLSTAENDIG_KI"
        @changeValue="$emit('changeValue', $event)"
      />
    </v-col>
    <v-col
      v-if="hasColumn('RK_AUTOM_BELEGERKENNUNG')"
      cols="12"
      :sm="hasColumn('RK_SONSTIGEBELEGE_VOLLSTAENDIG_KI') ? 6 : 12"
      class="py-0 tight-top"
      :style="
        !hasColumn('RK_SONSTIGEBELEGE_VOLLSTAENDIG_KI')
          ? 'flex: 0 0 100%; max-width: 100%;'
          : undefined
      "
    >
      <EditCheckBox
        kennung="RK_AUTOM_BELEGERKENNUNG"
        @changeValue="$emit('changeValue', $event)"
      />
    </v-col>
    <v-col v-if="hasColumn('MEMO_MEMO')" cols="12" class="py-0 tight-top">
      <EditTextArea
        kennung="MEMO_MEMO"
        @changeValue="$emit('changeValue', $event)"
      />
    </v-col>
  </v-row>
</template>

<style scoped>
.statuszahlung-col :deep(.wrap) {
  margin-top: -20px;
}
.tight-top :deep(.wrap) {
  margin-top: -12px;
}
</style>
